module.exports = __webpack_public_path__ + "img/wu.d51499fa.png";